import { render, staticRenderFns } from "./addTask.vue?vue&type=template&id=780576ec&scoped=true"
import script from "./addTask.vue?vue&type=script&lang=js"
export * from "./addTask.vue?vue&type=script&lang=js"
import style0 from "./addTask.vue?vue&type=style&index=0&id=780576ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780576ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('780576ec')) {
      api.createRecord('780576ec', component.options)
    } else {
      api.reload('780576ec', component.options)
    }
    module.hot.accept("./addTask.vue?vue&type=template&id=780576ec&scoped=true", function () {
      api.rerender('780576ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/addTask.vue"
export default component.exports